import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AuthService from "../../services/users/votedproduct.service";

export const getVotedProducts = createAsyncThunk(
  "uservoted/get", async (thunkAPI) => {

    try {
      const data = await AuthService.getVotedProducts();
      return data.docs;
    } catch (error) {
      console.log(error, "error during user voted product info")
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = { isLoader: false, userVoted: null };

const votedProductSlice = createSlice({
  name: "votedproducts",
  initialState,
  extraReducers: {
    [getVotedProducts.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.userVoted = action.payload
    }
  },
});

const { reducer } = votedProductSlice;
export default reducer;